// src/pages/VideosAdmin.jsx
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { getCurrentUser } from "../utils/auth";
import { getAllSeries, deleteSeries } from "../utils/seriesUtils";
import { getAllMovies, deleteMovie } from "../utils/movieUtils";
import "../styles/styles.css";

const VideosAdmin = () => {
  const navigate = useNavigate();
  const user = getCurrentUser();
  const [series, setSeries] = useState([]);
  const [movies, setMovies] = useState([]);

  useEffect(() => {
    if (!user || user.role !== "admin") {
      navigate("/");
    } else {
      setSeries(getAllSeries());
      setMovies(getAllMovies());
    }
  }, [user, navigate]);

  const handleDeleteSeries = (id) => {
    if (window.confirm("¿Borrar serie?")) {
      deleteSeries(id);
      setSeries(getAllSeries());
    }
  };

  const handleDeleteMovie = (id) => {
    if (window.confirm("¿Borrar película?")) {
      deleteMovie(id);
      setMovies(getAllMovies());
    }
  };

  return (
    <div className="admin-container">
      <h2>Gestión Vídeos</h2>

      <section>
        <h3>Series</h3>
        {series.length === 0 ? (
          <p style={{ color: "var(--color-text-secondary)" }}>No hay series.</p>
        ) : (
          <table className="admin-table">
            <thead>
              <tr>
                <th>Título</th>
                <th>Estreno</th>
                <th>Acciones</th>
              </tr>
            </thead>
            <tbody>
              {series.map((s) => (
                <tr key={s.id}>
                  <td>{s.title}</td>
                  <td>{s.releaseDate}</td>
                  <td>
                    <button
                      className="btn-small btn-reject"
                      onClick={() => handleDeleteSeries(s.id)}
                    >
                      Borrar
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </section>

      <section style={{ marginTop: "2rem" }}>
        <h3>Películas</h3>
        {movies.length === 0 ? (
          <p style={{ color: "var(--color-text-secondary)" }}>No hay películas.</p>
        ) : (
          <table className="admin-table">
            <thead>
              <tr>
                <th>Título</th>
                <th>Estreno</th>
                <th>Acciones</th>
              </tr>
            </thead>
            <tbody>
              {movies.map((m) => (
                <tr key={m.id}>
                  <td>{m.title}</td>
                  <td>{m.releaseDate}</td>
                  <td>
                    <button
                      className="btn-small btn-reject"
                      onClick={() => handleDeleteMovie(m.id)}
                    >
                      Borrar
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </section>
    </div>
  );
};

export default VideosAdmin;
